var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormInput',_vm._g(_vm._b({staticClass:"FormPriceInput",attrs:{"content-wrapper-class":"d-flex"}},'FormInput',{..._vm.$attrs, ..._vm.$props},false),_vm.$listeners),[_c('span',{staticClass:"currency-wrapper d-flex justify-content-center align-items-center flex-shrink-0"},[_vm._v("\n    €\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }